const STORAGE_KEY = 'lia_referral_ref';
const VISITOR_KEY = 'lia_visitor_id';
const TTL_DAYS = 30;

/** Stable per-browser visitor identifier used to deduplicate referral clicks. */
export function getVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = (crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return 'anonymous';
  }
}


interface StoredRef {
  code: string;
  ts: number;
}

/**
 * Reads ?ref= from the current URL (any public page) and stores it for 30 days.
 * Returns the captured code, or null when the URL has none.
 */
export function captureReferralFromUrl(search: string): string | null {
  try {
    const params = new URLSearchParams(search);
    const raw = params.get('ref');
    if (!raw) return null;
    const code = raw.trim().toUpperCase().slice(0, 40);
    if (!code) return null;
    const payload: StoredRef = { code, ts: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return code;
  } catch {
    /* storage unavailable */
    return null;
  }
}


/** Returns the stored referral code if it hasn't expired. */
export function getStoredReferral(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredRef;
    if (!parsed?.code) return null;
    const ageDays = (Date.now() - (parsed.ts ?? 0)) / 86_400_000;
    if (ageDays > TTL_DAYS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed.code;
  } catch {
    return null;
  }
}

export function clearStoredReferral(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
